import {
  Wallet,
  ListWalletRequest,
  WalletServiceClient,
  UpdateWalletRequest,
  ListContraWalletRequest,
} from '../proto/bankpb/wallet_grpc_web_pb';
import { auth } from '../lib/auth/Auth';
import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new WalletServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function listWallet(param, paging) {
  return new Promise((resolve, reject) => {
    const req = new ListWalletRequest();
    req.setStatus(param.status);
    req.setSymbol(param.symbol);
    req.setAccountNo(param.accountNo);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listWallet(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
export async function listContraWallet(param) {
  return new Promise((resolve, reject) => {
    const req = new ListContraWalletRequest();
    req.setStatus(param.status);
    req.setWalletId(param.walletId);

    service.listWalletAddressBookContraWallet(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function createWallet(param) {
  return new Promise((resolve, reject) => {
    let req = new Wallet();
    req.setNote(param.note);
    req.setSymbol(param.symbol);
    req.setStatus(param.status);
    req.setWallet(param.wallet);
    req.setAccountNo(param.accountNo);
    req.setAccountId(param.accountId);

    service.createWallet(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateWallet(param) {
  return new Promise((resolve, reject) => {
    const req = new UpdateWalletRequest();
    req.setWalletId(param.walletId);
    req.setSymbol(param.symbol);
    req.setStatus(param.status);
    req.setNote(param.note);

    service.updateWallet(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
